const normalizeAmcName = (value?: string | null) =>
  (value ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const AMC_LOGO_FILE_MAP: Record<string, string> = {
  "360 one mutual fund": "360 one.svg",
  "aditya birla sun life mutual fund": "Aditya Birla.svg",
  "axis mutual fund": "Axis.svg",
  "bajaj finserv mutual fund": "Bajaj.svg",
  "bandhan mutual fund": "Bandhan.svg",
  "bank of india mutual fund": "Bank of India.svg",
  "baroda bnp paribas mutual fund": "Baroda BNP.svg",
  "canara robeco mutual fund": "Canara.svg",
  capitalmind: "Capitalmind.svg",
  "dsp mutual fund": "DSP.svg",
  "edelweiss mutual fund": "Edelweiss.svg",
  "franklin templeton mutual fund": "Franklin Templeton Investment.svg",
  "groww mutual fund": "Groww.svg",
  "hdfc mutual fund": "HDFC.svg",
  "helios mutual fund": "Helios.svg",
  "hsbc mutual fund": "HSBC.svg",
  "icici prudential mutual fund": "ICICI.svg",
  "invesco mutual fund": "Invesco.svg",
  "iti mutual fund": "ITI.svg",
  "jm financial mutual fund": "JM.svg",
  "jio blackrock mutual fund": "Jio Blackrock.svg",
  "kotak mahindra mutual fund": "Kotak.svg",
  "l t mutual fund": "L&T.svg",
  "l&t mutual fund": "L&T.svg",
  "lic mutual fund": "LIC.svg",
  "mahindra manulife mutual fund": "Mahindra Manulife.svg",
  "mirae asset management": "Mirae Asset.svg",
  "mirae asset mutual fund": "Mirae Asset.svg",
  "motilal oswal mutual fund": "Motital Oswal.svg",
  "navi mutual fund": "Navi.svg",
  "nj mutual fund": "NJ.svg",
  "old bridge mutual fund": "Old brifge.svg",
  "nippon india mutual fund": "Nippon.svg",
  "ppfas mutual fund": "Parag parekh.svg",
  "pgim india mutual fund": "PGIM.svg",
  "quant mutual fund": "Quant.svg",
  "quant mutual fund sif": "Quant.svg",
  "quantum mutual fund": "Quantam.svg",
  "samco mutual fund": "Samco.svg",
  "sbi mutual fund": "SBI.svg",
  "sbi mutual fund sif": "SBI.svg",
  "shriram mutual fund": "Shriram.svg",
  "sundaram mutual fund": "Sundaram.svg",
  "tata mutual fund": "TATA.svg",
  "taurus mutual fund": "Taurus.svg",
  "trust mutual fund": "Trust.svg",
  "unifi mutual fund": "Unifi.svg",
  "union mutual fund": "Union.svg",
  "uti mutual fund": "UTI.svg",
  "whiteoak capital mutual fund": "Whiteoak.svg",
  "zerodha mutual fund": "Zerodha.svg",
};

export const getAmcLogoUrl = (amcName?: string | null) => {
  const key = normalizeAmcName(amcName);
  if (!key) return undefined;
  const file = AMC_LOGO_FILE_MAP[key];
  return file ? `/amcs/${encodeURIComponent(file)}` : undefined;
};

export { normalizeAmcName };
